var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSetMenuWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 -0.75L7.875 14.25",
    transform: "translate(-326.000000, -27.000000) translate(25.000000, 22.000000) translate(262.000000, 6.000000) translate(39.000000, 0.000000) translate(4.125000, 5.250000) translate(7.875000, 6.750000) scale(-1, 1) rotate(90.000000) translate(-7.875000, -6.750000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 8.25L10.875 17.25",
    transform: "translate(-326.000000, -27.000000) translate(25.000000, 22.000000) translate(262.000000, 6.000000) translate(39.000000, 0.000000) translate(4.125000, 5.250000) translate(10.875000, 12.750000) scale(-1, 1) rotate(90.000000) translate(-10.875000, -12.750000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 -6.75L7.875 8.25",
    transform: "translate(-326.000000, -27.000000) translate(25.000000, 22.000000) translate(262.000000, 6.000000) translate(39.000000, 0.000000) translate(4.125000, 5.250000) translate(7.875000, 0.750000) scale(-1, 1) rotate(90.000000) translate(-7.875000, -0.750000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetMenuWhite);
export default __webpack_public_path__ + "static/media/icon-set-menu-white.bda8268f31eef7ef593d171e580665df.svg";
export { ForwardRef as ReactComponent };